// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "styles/wp-" + {"128":"e20107efe18d1310504e","169":"b52d627c86f0c2a24d53","333":"6924891cd309bea0a679","503":"dbd12b9076caa25aaccf"}[chunkId] + ".css";
};